import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import innovativePackagingData from '../../../data/innovativePackagingData';
import SEO from '../../../components/SEO';
import '../ProductDetail.css';

const InnovativePackagingProduct = () => {
  const { category, product } = useParams();
  const categoryData = innovativePackagingData[category];
  const productData = categoryData && categoryData.products.find((p) => p.slug === product);

  if (!categoryData || !productData) {
    return <Navigate to="/products/innovative-protective-packaging" replace />;
  }

  return (
    <div className="product-detail-page">
      <SEO
        title={productData.name}
        description={`${productData.subtitle} — ${productData.bullets[0]}.`}
        path={`/products/innovative-protective-packaging/${category}/${product}`}
      />
      {/* Hero Section */}
      <section className="product-detail-hero">
        <div className="product-detail-hero-overlay"></div>
        <div className="container">
          <h1 className="product-detail-hero-title">{productData.name}</h1>
        </div>
      </section>

      {/* Main Title */}
      <section className="product-detail-intro">
        <div className="container">
          <h2 className="product-detail-main-title">{productData.subtitle}</h2>
        </div>
      </section>

      {/* Product Content */}
      <section className="product-intro-section">
        <div className="container">
          <div className="intro-content">
            <div className="intro-image">
              <img src={productData.image} alt={productData.name} />
            </div>
            <div className="intro-text">
              <h3 className="intro-subtitle">{productData.name} Highlights</h3>
              <ul className="why-list">
                {productData.bullets.map((bullet, index) => (
                  <li key={index} className="why-item">{bullet}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Back to category / CTA */}
      <section className="why-applications-section">
        <div className="container">
          <div className="why-applications-grid single-column">
            <div className="applications-column">
              <h2 className="section-title">Interested in {productData.name}?</h2>
              <p className="intro-paragraph">
                Get in touch with our team for pricing, samples, or help choosing the right {categoryData.title.toLowerCase()} system.
              </p>
              <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginTop: '10px' }}>
                <Link to="/contact" className="btn-cta-primary">
                  Contact Us
                </Link>
                <Link
                  to={`/products/innovative-protective-packaging/${category}`}
                  className="btn-cta-primary"
                >
                  Back to {categoryData.title}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InnovativePackagingProduct;
